import { render } from "./SystemTabOffline.vue?vue&type=template&id=6d0cb389&scoped=true&ts=true"
import script from "./SystemTabOffline.vue?vue&type=script&lang=ts"
export * from "./SystemTabOffline.vue?vue&type=script&lang=ts"

import "./SystemTabOffline.vue?vue&type=style&index=0&id=6d0cb389&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0cb389"]])

export default __exports__